/**
 * 소리(음성·알림) 설정 페이지
 * 레거시 _sky__m_menu_setting_08_02.php (= _sky__m_menu_setting_08.php?ontab=2) 대체
 *
 * Blade 는 정적 스켈레톤만 제공하고, 초기 상태/리스트 렌더와 모든 분기 처리는
 * 이 모듈의 initialize()→_renderInitialState() 에서 cfg(blade #page-data)를 읽어 수행한다.
 */
const ON  = '/img/m/opt_onoffbtn_on_rnw.svg';
const OFF = '/img/m/opt_onoffbtn_off_rnw.svg';
/** 토글 이미지 + 옆 상태 글자(켜짐/꺼짐) — 환경설정과 같은 모양 */
function setToggle(id, on) {
    $('#' + id).attr('src', on ? ON : OFF);
    $(`.snd-toggle-state[data-for="${id}"]`).text(on ? '켜짐' : '꺼짐').toggleClass('is-on', on);
}
const RADIO_ON  = '/img/m/radio_optionsel_001_on.png';
const RADIO_OFF = '/img/m/radio_optionsel_001_off.png';

export default class SettingSound {
    constructor() {
        const c = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        this.cfg = c;
        this.memPushRecive   = parseInt(c.memPushRecive, 10) === 1 ? 1 : 0;
        this.usePushSpeech   = parseInt(c.usePushSpeech, 10) === 1 ? 1 : 0;
        this.useSpeechType   = parseInt(c.useSpeechType, 10) === 2 ? 2 : 1;
        this.memSoojoPushget = parseInt(c.memSoojoPushget, 10);
        this.matchingFn      = c.matchingSnd || 'notisnd';
        this.noticeFn        = c.notiSnd || 'def';
        this.readPitch       = parseFloat(c.readPitch) || 1;
        this.readSpeed       = parseFloat(c.readSpeed) || 1;
    }

    initialize() {
        this._renderInitialState();
        this._bindEvents();
        this.showCurrentSetStr();
        if ($j.F.App && typeof $j.F.App.getDeviceContext === 'function') {
            $j.F.App.getDeviceContext();
        }
    }

    // 정적 스켈레톤 위에 cfg 기반 초기 상태/리스트를 렌더 (구 Blade @if/@foreach 대체)
    _renderInitialState() {
        // 소리 ON/OFF + mmsetAfter 투명도
        setToggle('mem_push_reciveimg', this.memPushRecive === 1);
        $('#mmsetAfter').css('opacity', this.memPushRecive === 1 ? 1 : 0.3);

        // 매칭 음성서비스 토글 + 읽어주는 대상 row 노출(레거시 동작: SndOpt2/3 는 항상 노출)
        setToggle('useReadmgimg', this.usePushSpeech === 1);
        $('#SndOptReadmgnot').css('display', this.usePushSpeech === 1 ? 'block' : 'none');

        // 읽어주는 대상 라디오 (readtexttype1=매칭만(2), readtexttype2=접수만(1)) + 세그먼트 강조
        this._syncReadTypeUI();

        // 음성 톤/속도 슬라이더 + 라벨 (레거시: value*50, label=value*100)
        $('#myRange1').val(this.readPitch * 50);
        $('#myRange2').val(this.readSpeed * 50);
        $('#tonsSetvalue').text(Math.round(this.readPitch * 100));
        $('#speedSetvalue').text(Math.round(this.readSpeed * 100));

        // 매칭음/알림음 리스트 (cfg 전달, 폰기본소리는 알림음에만 포함됨)
        this._buildSoundTable('#snd_setTable1 tbody', this.cfg.matchingList || {}, this.matchingFn, 1);
        this._buildSoundTable('#snd_setTable2 tbody', this.cfg.noticeList   || {}, this.noticeFn,   2);
    }

    _buildSoundTable(sel, list, currentFn, act) {
        const $tbody = $(sel).empty();
        Object.entries(list).forEach(([fn, label]) => {
            const $ico = $('<i>').attr('id', 'sndType_' + act + '_' + fn);
            this._setRadio($ico, fn === currentFn);
            const $tr = $('<tr class="snd-pick">').attr('data-fn', fn).attr('data-act', act);
            $tr.append($('<td>').append($ico));
            $tr.append($('<td>').text(label));
            $tbody.append($tr);
        });
    }

    // 라디오(FA 아이콘) on/off 세팅 — 선택=노랑 체크원, 미선택=빈 원
    _setRadio($ico, on) {
        $ico.attr('class', 'snd-radio ' + (on ? 'is-on fa-solid fa-circle-check' : 'fa-regular fa-circle'));
    }

    _bindEvents() {
        const self = this;
        // 도움말 모달 (env 와 동일 패턴: backdrop + modal, .help-close / 배경 클릭으로 닫기)
        const openHelp  = () => { $('#help-backdrop').show(); $('#help-modal').css('display', 'flex'); };
        const closeHelp = () => { $('#help-backdrop').hide(); $('#help-modal').hide(); };
        $('#snd-help-open').on('click', openHelp);
        $('#help-modal').on('click', '.help-close', closeHelp);
        $('#help-backdrop').on('click', closeHelp);

        $('#snd-toggle-recive').on('click', () => self.toggleSound());
        $('#snd-toggle-read').on('click', () => self.toggleReadMsg());
        $('.snd-readtype').on('click', function () {
            self.setReadType(parseInt($(this).data('type'), 10));
        });
        $('#myRange1, #myRange2').on('input', function () { self._sliderLabel(this); });
        $('#myRange1, #myRange2').on('change', function () { self.onSlide(this); });
        // sndTable 행은 init 시 동적 생성되므로 delegated binding
        $(document).on('click', '.snd-pick', function () {
            self.pickSound($(this).data('fn'), parseInt($(this).data('act'), 10));
        });
    }

    _enabled() { return this.memPushRecive === 1; }

    _save(gokey, govalue) {
        $.ajax({ type: 'POST', url: '/m/ajax/setting/save', data: { gokey, govalue } });
    }

    toggleSound() {
        this.memPushRecive = this.memPushRecive === 1 ? 0 : 1;
        const on = this.memPushRecive === 1;
        setToggle('mem_push_reciveimg', on);
        this._save('mem_push_recive', this.memPushRecive);
        $('#mmsetAfter').css('opacity', on ? 1 : 0.3);
        const noticeOn = on ? 'YES' : 'NO';
        const matchingOn = parseInt(this.memSoojoPushget, 10) === 9 ? 'NO' : 'YES';
        $j.F.App.syncSettings({ push: { noticeOn, matchingOn } });
    }

    toggleReadMsg() {
        if (!this._enabled()) return;
        this.usePushSpeech = (this.usePushSpeech + 1) % 2;
        const on = this.usePushSpeech === 1;
        setToggle('useReadmgimg', on);
        $('#SndOptReadmgnot').css('display', on ? 'block' : 'none');
        this._save('use_push_speech', this.usePushSpeech);
        $j.F.App.syncSettings({ tts: { enabled: this.usePushSpeech, type: this.useSpeechType } });
    }

    setReadType(n) {
        if (!this._enabled()) return;
        this.useSpeechType = n === 2 ? 2 : 1;
        this._syncReadTypeUI();
        this._save('use_speech_type', this.useSpeechType);
        $j.F.App.syncSettings({ tts: { enabled: this.usePushSpeech, type: this.useSpeechType } });
    }

    // 읽어주는 대상: 라디오 아이콘 + 선택 세그먼트(.is-on) 강조 동기화
    _syncReadTypeUI() {
        this._setRadio($('#readtexttype1'), this.useSpeechType === 2);
        this._setRadio($('#readtexttype2'), this.useSpeechType === 1);
        $('.snd-readtype').removeClass('is-on')
            .filter('[data-type="' + this.useSpeechType + '"]').addClass('is-on');
    }

    _sliderLabel(el) {
        const ss = parseInt((el.value / 50) * 100, 10);
        if (el.id === 'myRange1') $('#tonsSetvalue').text(ss);
        if (el.id === 'myRange2') $('#speedSetvalue').text(ss);
    }

    onSlide(el) {
        if (!this._enabled()) return;
        if (el.value < 20) {
            el.value = 20;
            if (el.id === 'myRange1') $('#tonsSetvalue').text(40);
            if (el.id === 'myRange2') $('#speedSetvalue').text(40);
        }
        let readspeed = parseInt($('#myRange2').val(), 10);
        let readPitch = parseInt($('#myRange1').val(), 10);
        if (isNaN(readspeed)) readspeed = 100;
        if (isNaN(readPitch)) readPitch = 100;
        readspeed = (readspeed / 50.0).toFixed(2);
        readPitch = (readPitch / 50.0).toFixed(2);

        $.ajax({ type: 'POST', url: '/m/ajax/setting/tts-speed', data: { readspeed, readPitch } });
        $j.F.App.syncSettings({ tts: { speed: readspeed, pitch: readPitch } });
        $j.F.App.readTts('음성 톤과 속도 미리듣기입니다.');
    }

    pickSound(fn, act) {
        if (!this._enabled()) return;
        if (act === 1) this.matchingFn = fn; else this.noticeFn = fn;

        const tableId = act === 2 ? 'snd_setTable2' : 'snd_setTable1';
        $(`#${tableId} .snd-radio`).each((i, el) => this._setRadio($(el), false));
        this._setRadio($(`#sndType_${act}_${fn}`), true);

        $j.F.App.playSound(fn);
        this.showCurrentSetStr();
        this._applyIT();
    }

    _applyIT() {
        $j.F.App.syncSettings({ sound: { matchingFn: this.matchingFn, noticeFn: this.noticeFn } });
        $.ajax({
            type: 'POST', url: '/m/ajax/setting/sound-fn',
            data: { soundfn: this.matchingFn, noticdfn: this.noticeFn },
        });
    }

    // 선택된 라디오의 라벨을 매칭/알림 헤더에 표시
    showCurrentSetStr() {
        [['snd_setTable1', 'sSetTitle1'], ['snd_setTable2', 'sSetTitle2']].forEach(([tableId, titleId]) => {
            $(`#${tableId} tr`).each(function () {
                if ($(this).find('td:first .snd-radio').hasClass('is-on')) {
                    $(`#${titleId}`).text($(this).find('td').eq(1).text());
                }
            });
        });
    }
}
